export const API_KEY = 'AIzaSyD4sC9y1ZuFixIrd2F4VZvjC8lJmu5pXbY';
